/* KiiDS.SHOP Kolotoč 2.0 menu (snippets/kiids-nav.liquid, kiids-nav-sheet.liquid).
   Desktop: mega panels open on hover (with intent delay) or click, close on Esc / outside / leave; live card; "Zatoč".
   Phone: <dialog> sheet, opened by the burger and the bottom bar's "Kategórie".
   Header shrinks once the page scrolls. html.kiids-still skips the spin frames. */
(() => {
  const still = () => document.documentElement.classList.contains('kiids-still');
  const header = () => document.querySelector('header-component') || document.querySelector('header');

  /* ---------- desktop mega ---------- */
  const nav = document.querySelector('[data-kiids-nav]');
  if (nav) {
    const scrim = nav.parentElement.querySelector('[data-mega-scrim]');
    const items = [...nav.querySelectorAll('[data-mega-item]')];
    let open = null, openT = 0, closeT = 0;

    const place = () => {
      const h = header();
      if (h) nav.parentElement.style.setProperty('--kiids-nav-top', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px');
    };
    const show = (li, focusFirst) => {
      clearTimeout(closeT);
      if (open === li) return;
      if (open) hide(open, false);
      place();
      const btn = li.querySelector('button'), panel = li.querySelector('[data-mega]');
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      scrim.hidden = false;
      requestAnimationFrame(() => { panel.classList.add('is-open'); scrim.classList.add('is-open'); });
      open = li;
      if (focusFirst) panel.querySelector('a, button')?.focus();
    };
    const hide = (li, returnFocus) => {
      const btn = li.querySelector('button'), panel = li.querySelector('[data-mega]');
      btn.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      panel.hidden = true;
      if (open === li) {
        open = null;
        scrim.classList.remove('is-open');
        scrim.hidden = true;
      }
      if (returnFocus) btn.focus();
    };
    const hideSoon = () => { clearTimeout(openT); clearTimeout(closeT); closeT = setTimeout(() => open && hide(open, false), 260); };

    items.forEach((li) => {
      const btn = li.querySelector('button');
      li.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(closeT); clearTimeout(openT);
        openT = setTimeout(() => show(li, false), open ? 0 : 140); // moving between items switches at once
      });
      li.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') hideSoon(); });
      btn.addEventListener('click', () => (open === li ? hide(li, false) : show(li, false)));
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') { e.preventDefault(); show(li, true); }
      });
      li.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && open === li) { e.stopPropagation(); hide(li, true); }
      });
      li.addEventListener('focusout', (e) => { if (open === li && !li.contains(e.relatedTarget)) hide(li, false); });
      initCard(li);
    });
    // Arrow keys between top-level items.
    nav.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const tops = [...nav.querySelectorAll('.kiids-nav__top')];
      const i = tops.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      tops[(i + (e.key === 'ArrowRight' ? 1 : tops.length - 1)) % tops.length].focus();
    });
    scrim.addEventListener('pointerenter', hideSoon);
    scrim.addEventListener('click', () => open && hide(open, false));
    window.addEventListener('scroll', () => open && place(), { passive: true });
  }

  /* Live card: product by default, a hovered child collection swaps in, "Zatoč" spins a random product. */
  function initCard(li) {
    const card = li.querySelector('[data-card]');
    if (!card) return;
    const $ = (s) => card.querySelector(s);
    const img = $('[data-card-img]'), title = $('[data-card-title]'), meta = $('[data-card-meta]'), label = $('[data-card-label]');
    const links = [...card.querySelectorAll('[data-card-link]')], form = $('[data-card-form]'), say = $('[data-card-say]');
    const detail = card.querySelector('[data-card-buy] > a');
    let pool = [];
    try { pool = JSON.parse($('[data-pool]').textContent); } catch (e) { /* card stays static */ }
    let current = pool[0] || null, mode = 'product', spinning = false;

    const setImg = (src) => { if (src) { img.src = src; img.removeAttribute('srcset'); } };
    const product = (p, picked) => {
      if (!p) return;
      mode = 'product';
      card.classList.remove('is-coll', 'is-sticker');
      label.textContent = picked ? card.dataset.labelSpin : card.dataset.labelNow;
      setImg(p.i);
      title.textContent = p.t;
      meta.textContent = [p.b, p.p].filter(Boolean).join(' · ');
      links.forEach((a) => (a.href = p.u));
      if (form) {
        form.hidden = !p.v;
        const id = form.querySelector('[name=id]');
        if (id && p.v) id.value = p.v;
      }
      if (detail) detail.textContent = card.dataset.labelDetail;
    };
    const coll = (a) => {
      if (spinning || !a.dataset.collTitle) return;
      mode = 'coll';
      card.classList.add('is-coll');
      card.classList.toggle('is-sticker', 'collSticker' in a.dataset);
      card.dataset.bd = a.dataset.collBd || '';
      label.textContent = card.dataset.labelColl + ' · ' + a.dataset.collCount;
      setImg(a.dataset.collImg);
      title.textContent = a.dataset.collTitle;
      meta.textContent = '';
      links.forEach((l) => (l.href = a.href));
      if (form) form.hidden = true;
      if (detail) detail.textContent = card.dataset.labelOpen;
    };

    const cats = li.querySelector('[data-mega-cats]');
    cats?.querySelectorAll('a').forEach((a) => {
      a.addEventListener('pointerenter', () => coll(a));
      a.addEventListener('focus', () => coll(a));
    });
    cats?.addEventListener('pointerleave', () => mode === 'coll' && product(current, current !== pool[0]));

    const spin = li.querySelector('[data-mega-spin]');
    if (!spin || pool.length < 3) return;
    spin.addEventListener('pointerenter', () => pool.slice(0, 10).forEach((p) => (new Image().src = p.i)), { once: true });
    spin.addEventListener('click', () => {
      if (spinning) return;
      const others = pool.filter((p) => p !== current);
      const pick = others[Math.floor(Math.random() * others.length)];
      const done = () => {
        spinning = false;
        card.classList.remove('is-spinning');
        current = pick;
        product(pick, true);
        if (say) say.textContent = card.dataset.labelSpin + ': ' + pick.t;
      };
      if (still()) return done();
      spinning = true;
      card.classList.add('is-spinning');
      const frames = Array.from({ length: 9 }, () => others[Math.floor(Math.random() * others.length)]);
      frames.forEach((p, i) => setTimeout(() => { setImg(p.i); title.textContent = p.t; }, i * 70 + i * i * 6));
      setTimeout(done, 9 * 70 + 81 * 6 + 60);
    });
  }

  /* ---------- phone sheet ---------- */
  const sheet = document.querySelector('[data-sheet]');
  if (sheet && typeof sheet.showModal === 'function') {
    const openSheet = (e) => {
      e?.preventDefault();
      if (sheet.open) return;
      sheet.showModal();
      sheet.classList.remove('is-closing');
    };
    const closeSheet = () => {
      if (!sheet.open) return;
      if (still()) return sheet.close();
      sheet.classList.add('is-closing');
      setTimeout(() => { sheet.close(); sheet.classList.remove('is-closing'); }, 220);
    };
    // only this menu's own triggers: the collection filter sheet uses data-sheet-open too
    document.querySelectorAll(`[data-sheet-open][aria-controls="${sheet.id}"]`).forEach((b) => b.addEventListener('click', openSheet));
    // Bottom bar "Kategórie" (links to /collections) opens the sheet instead of the list page.
    document.querySelectorAll('.toolbar-mobile a[href$="/collections"]').forEach((a) => a.addEventListener('click', openSheet));
    sheet.querySelector('[data-sheet-close]').addEventListener('click', closeSheet);
    sheet.addEventListener('cancel', (e) => { e.preventDefault(); closeSheet(); });
    sheet.addEventListener('click', (e) => { if (e.target === sheet) closeSheet(); }); // backdrop
    window.matchMedia('(min-width: 990px)').addEventListener('change', (m) => m.matches && sheet.open && sheet.close());
  }

  /* ---------- header shrinks on scroll ---------- */
  const h = header();
  if (h) {
    let on = false;
    const check = () => {
      const y = window.scrollY;
      if (!on && y > 120) { on = true; h.classList.add('kiids-hdr--scrolled'); }
      else if (on && y < 40) { on = false; h.classList.remove('kiids-hdr--scrolled'); }
    };
    window.addEventListener('scroll', check, { passive: true });
    check();
  }
})();
